import React from "react";

const Maintenance = ({ logo}) => {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h2>
          Trwają prace porządkowe.<br />
          Strona w budowie.<br />
          Dziękujemy za cierpliwość.<br />
        </h2>
      </header>
    </div>
  );
};

export default Maintenance;